@if (toast.type === 'upload') {
  <app-progress-upload-toasts-item [toast]="toast"></app-progress-upload-toasts-item>
} @else if (toast.type === 'archive') {
  <app-progress-archive-toasts-item [toast]="toast"></app-progress-archive-toasts-item>
}
